const data = [{ id:1,
    img: "https://plus.unsplash.com/premium_photo-1661919210043-fd847a58522d?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    price: "1200",
    place_name: "Paris, France",
    description: "Experience the romance of Paris with visits to iconic landmarks such as the Eiffel Tower, Louvre Museum, and Notre-Dame Cathedral. Enjoy world-class dining and explore charming streets."
  },
  { id:2,
    img: "https://images.unsplash.com/photo-1711090915709-595f2417c60b?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    price: "1500",
    place_name: "Tokyo, Japan",
    description: "Discover the vibrant city of Tokyo, blending traditional culture with futuristic technology. Visit temples, explore bustling neighborhoods like Shibuya and Akihabara, and indulge in delicious sushi."
  },
  { id:3,
    img: "https://images.unsplash.com/photo-1448317971280-6c74e016e49c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bmV3JTIweW9yayUyMGNpdHl8ZW58MHx8MHx8fDA%3D",
    price: "1300",
    place_name: "New York City, USA",
    description: "Explore the bustling streets of New York City. Enjoy Broadway shows, visit landmarks such as the Statue of Liberty and Central Park, and experience diverse neighborhoods and cuisines."
  },
  { id:4,
    img: "https://images.unsplash.com/photo-1465057174976-39931c6308c9?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    price: "1400",
    place_name: "Sydney, Australia",
    description: "Discover the beauty of Sydney with its iconic Opera House, Bondi Beach, and vibrant arts scene. Enjoy outdoor activities and explore the stunning harbor and coastal landscapes."
  },
  { id:5,
    img: "https://images.unsplash.com/photo-1576485290814-1c72aa4bbb8e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    price: "1600",
    place_name: "Cape Town, South Africa",
    description: "Experience the scenic beauty of Cape Town. Visit Table Mountain, the V&A Waterfront, and explore the Cape Winelands. Enjoy a mix of adventure and relaxation in this picturesque city."
  },{
    id:6,
    img: "https://plus.unsplash.com/premium_photo-1661964123160-8d049fa07f0c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cm9tZSUyMGl0YWx5fGVufDB8fDB8fHww",
    price: "18000",
    place_name: "Rome",
    description: "The Eternal City, filled with ancient history and stunning architecture"
  },
  {id:7,
    img: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c3lkbmV5fGVufDB8fDB8fHww",
    price: "25000",
    place_name: "Sydney",
    description: "Famous for the Opera House, beautiful beaches, and vibrant wildlife"
  },
]

module.exports= data;